var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18.05 46.08" }, props),
    React.createElement("path", { d: "M0 45.82V22.1l.25-1.14 7.68-18.3L9.04 0l1.11 2.66 7.69 18.32.21 1.1v24m-2.66-.09V25.18H2.61v20.69m.67-24.82h11.35L8.97 7.57z", fill: "#306f82" }),
    React.createElement("path", { fill: "#306f82", d: "M8.5 7.1l-2.96 6.12 7.24 1.04L9.5 6.7l-1 .4z" })
  );
});